import React from 'react';
import { ReactSVG } from 'react-svg';
import styles from './icon.module.css';

export const Icon = (props) => {
  const { src, width, height, className, style, color } = props;

  return (
    <ReactSVG
      src={src}
      style={style}
      className={`${className} ${styles.icon}`}
      beforeInjection={(svg) => {
        svg.setAttribute('width', width);
        svg.setAttribute('height', height);
        if (color) {
          svg.querySelectorAll('path').forEach((path) => {
            path.setAttribute('stroke', color);
          });
        }
      }}
    />
  );
};
